import Swiper from 'swiper';

export default function carouselVehicle() {
    function vehicleCarouselInit() {
        $('.vehicle-carousel').each(function (index) {

            let $slides = $('.swiper-slide', $(this));

            if ($slides.length <= 8) {
                $(this).toggleClass('_has-single-slide');
            }

            if (window.innerWidth <= 600 && $slides.length > 1) {
                $(this).removeClass('_has-single-slide');
            }

            if (window.innerWidth <= 1024 && $slides.length > 6) {
                $(this).removeClass('_has-single-slide');
            }

            if ($slides.length == 2 && $('.vehicle-carousel').hasClass('vehicle-carousel--cart')) {
                $(this).addClass('_carousel-standalone');
            }

            let $this = $(this).find('.swiper-container');

            $this.parents('.carousel-wrap').find('.swiper-next-btn').addClass('swiper-next-btn-' + index);
            $this.parents('.carousel-wrap').find('.swiper-prev-btn').addClass('swiper-prev-btn-' + index);

            $('.vehicle-image').each(function (ind) {
                $(this).addClass('vehicle-image-' + ind);
            });

            $('.gallery-thumbs').each(function (ind) {
                $(this).addClass('gallery-thumb-' + ind);
            });

            let galleryThumbs = new Swiper('.gallery-thumb-' + index, {
                spaceBetween: 8,
                slidesPerView: 4,
                freeMode: true,
                watchSlidesVisibility: true,
                watchSlidesProgress: true,
                observer: true,
                observeParents: true,
                centerInsufficientSlides: true,
                resistanceRatio: 0,
                breakpoints: {
                    1199: {
                        slidesPerView: 3,
                    },
                    // 767: {
                    //     slidesPerView: 1,
                    // },
                }


            });

            let galleryTop = new Swiper('.vehicle-image-' + index, {
                speed: 500,
                spaceBetween: 10,
                slidesPerView: 1,
                observer: true,
                observeParents: true,
                centeredSlides: true,
                resistanceRatio: 0,
                navigation: {
                    nextEl: '.swiper-next-btn-' + index,
                    prevEl: '.swiper-prev-btn-' + index,
                },
                thumbs: {
                    swiper: galleryThumbs,
                },
                breakpoints: {
                    1023: {
                        spaceBetween: 20,
                    },
                    // 767: {
                    //
                    //     // slidesOffsetBefore: 115,
                    //     // slidesOffsetAfter: 115,
                    //     // centerInsufficientSlides: true,
                    // }
                }
            });
        });
    }

    vehicleCarouselInit();

    $(document).ajaxComplete(function() {
        vehicleCarouselInit();
    });

}